import React from "react"

const Item1 = () => {
  return (
    <p className="regular-parraf">
      Somos el mejor y más completo curso Online para la preparación del ENARM,
      encargado de abarcar completamente las exigencias del ENARM, proporcionándoles
      a los médicos <strong>las mejores herramientas</strong>, <strong>nuestro único y
        efectivo método de estudio y las mejores técnicas para estudiar con inteligencia</strong>
      y así desarrollar al 100% su potencial de retención,
      maximizar los resultados en las pruebas,
      obtener un mejor aprendizaje y memorización,
      <strong> para lograr el éxito en el ENARM.</strong>
    </p>
  )
}

export default Item1;